<template>
  <v-content>
    <el-tooltip placement="top" content="ブランド名を入力すると候補が表示されます">
      <el-autocomplete
        clearable
        id="selector-brand"
        :value="brandnameComputed"
        :fetch-suggestions="queryBrands"
        select-when-unmatched
        value-key="name"
        @select="changeBrand"
        @input="inputValue"
      >
        <template slot-scope="{ item }">
          <div :id="('brand-autocomplete-' + item.id)">{{item.name}} / {{item.phonetic}}</div>
        </template>
      </el-autocomplete>
    </el-tooltip>
    <el-row v-if="brandidComputed == 0 && brandnameComputed.length > 0">
      <span style="font-size: small;">
        BUYMAに登録されていないブランド名のため、ブランド検索には反映されません。
      </span>
    </el-row>
  </v-content>
</template>

<script>
import api from '@/http/api.js'

export default {
  name: 'BrandInputCore',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    brandname: {
      type: String,
      default: ''
    },
    brandid: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
      queryLoading: false,
      brandOptions: []
    }
  },
  watch: {
    brandid (newValue, oldValue) {
      if (newValue > 0 && this.brandname.length <= 0) {
        api.brand.getBrand(newValue).then(brand => {
          this.brandnameComputed = brand.name
        })
      }
    }
  },
  computed: {
    brandnameComputed: {
      get () {
        return this.brandname
      },
      set (value) {
        this.$emit('update:brandname', value)
      }
    },
    brandidComputed: {
      get () {
        return this.brandid
      },
      set (value) {
        console.log('brandidComputed set')
        this.$emit('update:brandid', value)
      }
    }
  },
  methods: {
    queryBrands (query, cb) {
      if (query === '') {
        const empty = []
        cb(empty)
      } else {
        api.brand.queryBrands(query).then(
          data => {
            cb(data)
          }
        ).catch(
          e => {
            cb()
          }
        )
      }
    },
    changeBrand (value) {
      console.log('changeBrand')
      console.log(value)
      this.brandnameComputed = value.name
      this.brandidComputed = value.id
    },
    inputValue (value) {
      console.log('inputValue')
      this.brandnameComputed = value
      this.brandidComputed = 0
    }

  }
}
</script>

<style>

</style>
